import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {routerReducer} from 'react-router-redux';
import thunk from 'redux-thunk';

import * as types from './actions/actionTypes';
import reducers from './reducers';
import history  from "./history";
import { connectRouter } from "connected-react-router";

let store;


export function getStore() {
  return store;
}

export function configureStore(callback) {
  // Configuration de redux-persist
  const persistConfig = {
    key: 'config3D',
    storage,
    whitelist: ['tutorial'], // Sauvegarder seulement le reducer 'tutorial'
    debounce: 1000, // Debounce de 1 seconde
  };

  // Combine tous les reducers
  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer // Pour synchroniser l'état de react-router dans le store
  });

  // Créer le reducer persistant
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const middlewares = [thunk];
  if (process.env.NODE_ENV === 'development') {
    // Utile pour logger les erreurs dans les actions, mais pollue la console.
    //middlewares.push(require('redux-logger')());
  }

  store = createStore(
    connectRouter(history)(persistedReducer),
    {}, // Etat initial
    compose(
      applyMiddleware(...middlewares),
      window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f // Redux DevTools
    )
  );

  // Créer le persistor
  const persistor = persistStore(store, null, () => {
    // Callback appelé une fois l'état restauré
    callback(store, history);
  });

  return { store, persistor };
}
